import { resourceSagaUtils, resourceStoreTypes } from 'app-components/flux/core';
import { takeEvery } from 'redux-saga/effects';

import * as actions from './transferBalanceActions';
import { getLastSyncDate } from './transferBalanceSelectors';
import { mkTransferBalance } from './transferBalanceTypes';

export function* getTransferBalanceActionWatcher() {
  const config = resourceStoreTypes.mkQcsSyncResourceConfig({
    resourceName: 'transfer history',
    resourceBaseUrl: '/transfers/balance',
    getLastSyncDate,
    successAction: actions.getTransferBalanceSuccess,
    failureAction: actions.getTransferBalanceFailure,
    transformResourceWithResponse: (_resource, response) =>
      response?.data && mkTransferBalance({ ...response.data, id: response.data.identityId }),
  });
  yield takeEvery(actions.getTransferBalance, resourceSagaUtils.qcsSyncCreateResource, config);
}

export default [getTransferBalanceActionWatcher];
